// removed by extract-text-webpack-plugin
module.exports = {"list-products":"list-products","product":"product","category":"category","image-category":"image-category","category-title":"category-title","viewmore-product":"viewmore-product"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_ProductsByCategory.scss
// module id = ./components/home/sub-view/_ProductsByCategory.scss
// module chunks = 0